import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'
import { useTranslation } from 'react-i18next'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation()
    const { addFilter } = useSettingsContext(dataProviderName);
    const { drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set">
            <KPI
                title="Reports"
                icon="faChartSimple"
                dataProviderName={'statistics/total/countmine/bis/bi'}
            />
            <KPI
                title="Executive"
                icon="faGlobe"
                dataProviderName={'statistics/executive/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => {addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator)}
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "equals",
                        value: "sales_executive"
                    }]
                }}
            />
            <KPI
                title="Area"
                icon="faGlobeStand"
                dataProviderName={'statistics/area/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => {addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator)}
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "equals",
                        value: "sales_area"
                    }]
                }}
            />
            <KPI
                title="Shop"
                icon="faShop"
                dataProviderName={'statistics/area/countmine/bis/bi'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => {addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator)}
                }}
                filters={{
                    items: [{
                        field: "scope",
                        operator: "equals",
                        value: "sales_shop"
                    }]
                }}
            />

        </Box>
    )
}

export default KPISet;